import React from 'react';
import { Users, Target } from 'lucide-react';
import { mockData } from '../utils/mock';

export const TargetAudience = () => {
  return (
    <section className="relative py-24 bg-zinc-900">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-500/20 rounded-full mb-6">
            <Users className="w-8 h-8 text-orange-500" />
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            {mockData.targetAudience.title}
          </h2>
          <p className="text-xl text-white/70">
            {mockData.targetAudience.description}
          </p>
        </div>

        {/* Criteria Grid */}
        <div className="grid sm:grid-cols-2 gap-6 mb-12">
          {mockData.targetAudience.criteria.map((criterion, index) => (
            <div
              key={index}
              className="flex items-start gap-4 p-6 bg-black/40 border border-white/10 rounded-xl hover:border-orange-500/50 hover:bg-black/60 transition-all duration-300 group"
            >
              <div className="flex-shrink-0 w-8 h-8 bg-orange-500/20 rounded-lg flex items-center justify-center group-hover:bg-orange-500/30 transition-colors duration-300">
                <Target className="w-5 h-5 text-orange-500" />
              </div>
              <p className="text-white/90 group-hover:text-white transition-colors duration-300">
                {criterion}
              </p>
            </div>
          ))}
        </div>

        {/* Not For / For Who */}
        <div className="text-center space-y-4 p-8 bg-gradient-to-br from-orange-500/10 via-transparent to-transparent border border-orange-500/20 rounded-2xl">
          <p className="text-xl text-white/80">
            {mockData.targetAudience.notFor}
          </p>
          <p className="text-2xl text-white font-bold">
            {mockData.targetAudience.forWho}
          </p>
        </div>
      </div>
    </section>
  );
};
